import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  get sharedRubyVariables() {
    return document.querySelector('#js-shared-ruby-variables').dataset;
  }
}